import { baseApi } from '../../core/api/rtk/baseApi';

export const taskDetailApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTaskCompletionsForTask: builder.query<
      any,
      {
        taskId: number;
        page: number;
        pageSize: number;
        fromDate: string;
        untilDate: string;
        notes?: number;
        siteId?: number | null;
      }
    >({
      query: ({ taskId, page, pageSize, fromDate, untilDate, notes = 0 }) => {
        const params = new URLSearchParams();
        params.set('page', String(page));
        params.set('pageSize', String(pageSize));
        params.set('direction', 'desc');
        params.set('fromDate', fromDate);
        params.set('untilDate', untilDate);
        params.set('notes', String(notes));
        return { url: `tasks/${taskId}/completions?${params.toString()}` };
      },
    }),
  }),
});

export const { useGetTaskCompletionsForTaskQuery } = taskDetailApi;
